import { render } from "./MyEntries.vue?vue&type=template&id=16d38a5e"
import script from "./MyEntries.vue?vue&type=script&lang=js"
export * from "./MyEntries.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__